import React, { memo } from 'react'
import { useSelector } from 'react-redux'
import { GSIcon } from 'src/components/shared/GSIcon'
import { LimitedStringChip } from 'src/components/shared/LimitedStringChip'
import { getMarkets } from 'src/selectors/market'
import { TableSelect } from './TableSelect'

interface Props {
  selectedMarketIds: Array<string>
  setSelectedMarketIds(marketIds: Array<string>): void
  title?: string
  triggerDataTestId?: string
  clearAllDataTestId?: string
  searchInputDataTestId?: string
}

/**
 * Searchable multi-select over the customer's markets, matching TableAssignedTemplateSelect.
 * A partner can have a hundred markets, so this has to be searchable rather than a checkbox list.
 */
const TableMarketSelectComponent = ({
  selectedMarketIds,
  setSelectedMarketIds,
  title = 'Markets',
  triggerDataTestId,
  clearAllDataTestId,
  searchInputDataTestId,
}: Props) => {
  const markets = useSelector(getMarkets)

  return (
    <TableSelect<string>
      title={title}
      selectedValues={selectedMarketIds}
      icon={<GSIcon iconName="gs_buildings" width={20} height={20} />}
      options={(markets || []).map((item: any) => ({
        value: item.id,
        label: item.title,
        component: <LimitedStringChip text={item.title} />,
      }))}
      searchable
      searchPlaceholder="Search"
      menuWidth={258}
      onSelect={setSelectedMarketIds}
      triggerDataTestId={triggerDataTestId}
      clearAllDataTestId={clearAllDataTestId}
      searchInputDataTestId={searchInputDataTestId}
    />
  )
}

export const TableMarketSelect = memo(TableMarketSelectComponent)
